import angular from 'angular';

class UsersRevokeModalContainer {
  constructor(appEvents, permissions, USERS_EVENTS) {
    'ngInject';

    this.appEvents = appEvents;
    this.permissions = permissions;
    this.USERS_EVENTS = USERS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.USERS_EVENTS.revoke.open,
      (user, brandsList) => this.openModal(
        user,
        angular.copy(brandsList),
      ),
    );

    this.modalTitle = 'Revoke Permissions';
    this.user = {};
    this.brandsList = [];
    this.open = false;
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  updateModalTitle(brands) {
    let title = '';
    if (brands.length === 1) {
      const [brand] = brands;
      title = `Revoke Permissions For ${brand.displayName}`;
    } else {
      title = `Revoke Permissions For ${brands.length} Selected Accounts`;
    }

    this.modalTitle = title;
  }
  openModal(user, brandsList) {
    this.user = user;
    this.brandsList = brandsList;
    this.open = true;
    this.updateModalTitle(this.brandsList);
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.USERS_EVENTS.revoke.close);
  }
  saveModal() {
    this.appEvents.emit(this.USERS_EVENTS.revoke.save);
    this.closeModal();
  }
}

export default {
  controller: UsersRevokeModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
    >
      <revoke-form-container
        on-save="$ctrl.saveModal()"
        on-cancel="$ctrl.closeModal()"

        owner-label="Email"
        owner-caption="$ctrl.user.email"

        brands-list="$ctrl.brandsList"
        show-brands="true"
        on-brands-change="$ctrl.updateModalTitle(brands)"
        available-brands="$ctrl.user.customer_accounts"

        users-list="[$ctrl.user]"
        show-users="false"
      ></revoke-form-container>
    </modal-wrapper>
  `,
};
